import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import stickybits from 'stickybits'

import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';

const slug = {
  es: ['rutas-y-horarios', 'viajar-en-ferry', 'atencion-al-cliente', 'sobre-romeu-ferries', 'localiza-tu-billete',
       'ferries-desde-alicante', 'ferries-desde-barcelona', 'ferries-a-oran', 'ferries-a-mostaganem', 'ferries-a-argel',],
  fr: ['itineraires-et-horaires', 'voyage-en-ferry', 'attention-au-client', 'a-propos-des-ferries-romeu', 'reperez-votre-billet',
       'ferries-d-alicante', 'ferries-d-barcelona', 'ferries-a-oran', 'ferries-a-mostaganem', 'ferries-a-argel']
}


class header extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      openMenu: false,
      openSubMenu: false,
    };
  }

  handleMenuClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openMenu: true,
      anchorMenuEl: event.currentTarget,
    });
  };

  handleMenuRequestClose = () => {
    this.setState({
      openMenu: false,
    });
  };

  handleSubMenuClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openSubMenu: true,
      anchorSubMenuEl: event.currentTarget,
    });
  };

  handleSubMenuRequestClose = () => {
    this.setState({
      openSubMenu: false,
    });
  };

  onClick = (to) => {
    window.scrollTo(0, 0)
    this.handleSubMenuRequestClose()
    this.context.router.history.push(to)
  }

  render() {
    const { isMenu } = this.props
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].header

    const path = this.context.router.route.location.pathname
    const lang = path.split('/')[1]

    return (
      <header id="header">

        <div className="top-section">
          <div className="container">
            <div className="flex-row">
              <a href={`/${lang}`}><span className="brand heavy no-margin" ><span className="romeu">ROMEU</span><span className="ferries">FERRIES</span></span></a>
              {(isMenu)?
                <div className="general-menu">
                  <nav className="menu">
                    <ul className="menu-list no-margin regular">
                      <li className="menu-list-item" onClick={this.handleSubMenuClick}>
                        {langPlace.routesandschedules}
                        <Popover
                          open={this.state.openSubMenu}
                          anchorEl={this.state.anchorSubMenuEl}
                          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                          targetOrigin={{horizontal: 'left', vertical: 'top'}}
                          onRequestClose={this.handleSubMenuRequestClose}
                        >
                          <Menu style={{ textTransform: 'uppercase' }} menuItemStyle={{ fontSize: 14 }}>
                            <MenuItem  primaryText={langPlace.ferrysalicante} onClick={() => this.onClick(`/${lang}/${slug[lang][5]}`)} />
                            <MenuItem  primaryText={langPlace.ferrysbarcelona} onClick={() => this.onClick(`/${lang}/${slug[lang][6]}`)} />
                            <MenuItem  primaryText={langPlace.ferrysoran} onClick={() => this.onClick(`/${lang}/${slug[lang][7]}`)} />
                            <MenuItem  primaryText={langPlace.ferrysmostaganem} onClick={() => this.onClick(`/${lang}/${slug[lang][8]}`)} />
                            <MenuItem  primaryText={langPlace.ferrysargel} onClick={() => this.onClick(`/${lang}/${slug[lang][9]}`)} />
                          </Menu>
                        </Popover>

                      </li>
                      <li className="menu-list-item" ><Link to={`/${lang}/${slug[lang][1]}`}>{langPlace.travelbyferry}</Link></li>
                      <li className="menu-list-item" ><Link to={`/${lang}/${slug[lang][2]}`}>{langPlace.customersupport}</Link></li>
                      <li className="menu-list-item" ><Link to={`/${lang}/${slug[lang][3]}`}>{langPlace.aboutromeu}</Link></li>
                      <li className="menu-list-item" ><Link to={`/${lang}/${slug[lang][4]}`}>{langPlace.locatereservation}</Link></li>
                    </ul>
                  </nav>
                  <div className='header-toolbar responsive-hamburger'>

                      <i onClick={this.handleMenuClick} className="fa fa-bars header-menu" aria-hidden="true"></i>
                      <Popover
                        open={this.state.openMenu}
                        anchorEl={this.state.anchorMenuEl}
                        anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                        targetOrigin={{horizontal: 'left', vertical: 'top'}}
                        onRequestClose={this.handleMenuRequestClose}
                      >
                        <Menu style={{ textTransform: 'uppercase' }} menuItemStyle={{ fontSize: 14 }}>
                          <MenuItem  primaryText={langPlace.routesandschedules}
                            rightIcon={<ArrowDropRight />}
                            menuItems={[
                              <MenuItem  primaryText={langPlace.ferrysalicante} onClick={() => this.onClick(`/${lang}/${slug[lang][5]}`)} />,
                              <MenuItem  primaryText={langPlace.ferrysbarcelona} onClick={() => this.onClick(`/${lang}/${slug[lang][6]}`)} />,
                              <MenuItem  primaryText={langPlace.ferrysoran} onClick={() => this.onClick(`/${lang}/${slug[lang][7]}`)} />,
                              <MenuItem  primaryText={langPlace.ferrysmostaganem} onClick={() => this.onClick(`/${lang}/${slug[lang][8]}`)} />,
                              <MenuItem  primaryText={langPlace.ferrysargel} onClick={() => this.onClick(`/${lang}/${slug[lang][9]}`)} />,
                            ]}
                          />
                          <MenuItem  primaryText={langPlace.travelbyferry} onClick={() => this.onClick(`/${lang}/${slug[lang][1]}`)} />
                          <MenuItem  primaryText={langPlace.customersupport} onClick={() => this.onClick(`/${lang}/${slug[lang][2]}`)} />
                          <MenuItem  primaryText={langPlace.aboutromeu} onClick={() => this.onClick(`/${lang}/${slug[lang][3]}`)} />
                          <MenuItem  primaryText={langPlace.locatereservation} onClick={() => this.onClick(`/${lang}/${slug[lang][4]}`)} />
                        </Menu>
                      </Popover>

                  </div>
                </div>
              :
                <div className='header-toolbar'>

                    <i onClick={this.handleMenuClick} className="fa fa-bars header-menu" aria-hidden="true"></i>
                    <Popover
                      open={this.state.openMenu}
                      anchorEl={this.state.anchorMenuEl}
                      anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                      targetOrigin={{horizontal: 'left', vertical: 'top'}}
                      onRequestClose={this.handleMenuRequestClose}
                    >
                      <Menu style={{ textTransform: 'uppercase' }} menuItemStyle={{ fontSize: 14 }}>
                        <MenuItem  primaryText={langPlace.routesandschedules}
                          rightIcon={<ArrowDropRight />}
                          menuItems={[
                            <MenuItem  primaryText={langPlace.ferrysalicante} onClick={() => this.onClick(`/${lang}/${slug[lang][5]}`)} />,
                            <MenuItem  primaryText={langPlace.ferrysbarcelona} onClick={() => this.onClick(`/${lang}/${slug[lang][6]}`)} />,
                            <MenuItem  primaryText={langPlace.ferrysoran} onClick={() => this.onClick(`/${lang}/${slug[lang][7]}`)} />,
                            <MenuItem  primaryText={langPlace.ferrysmostaganem} onClick={() => this.onClick(`/${lang}/${slug[lang][8]}`)} />,
                            <MenuItem  primaryText={langPlace.ferrysargel} onClick={() => this.onClick(`/${lang}/${slug[lang][9]}`)} />,
                          ]}
                        />
                        <MenuItem  primaryText={langPlace.travelbyferry} onClick={() => this.onClick(`/${lang}/${slug[lang][1]}`)} />
                        <MenuItem  primaryText={langPlace.customersupport} onClick={() => this.onClick(`/${lang}/${slug[lang][2]}`)} />
                        <MenuItem  primaryText={langPlace.aboutromeu} onClick={() => this.onClick(`/${lang}/${slug[lang][3]}`)} />
                        <MenuItem  primaryText={langPlace.locatereservation} onClick={() => this.onClick(`/${lang}/${slug[lang][4]}`)} />
                      </Menu>
                    </Popover>

                </div>
              }
            </div>
          </div>
        </div>

      </header>
    );
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(header)



// WEBPACK FOOTER //
// ./src/shared/routes/components/header.js